import styled from "styled-components"
import Box from "../UI/Box"
import Text from "../UI/Text"
import useUser from "~/modules/user/useUser"
import Icon from "../UI/Icon"
import Separator from "../UI/Separator"
import Link from "next/link"
import StyledLink from '~/components/UI/Link'
import { ROUTES, HOTLINE } from "~/constant"
import { useMemo, useCallback } from "react"
import Avatar from '~/components/UI/Avatar'
import Button from "~/components/UI/Button"
import signOut from "~/utils/authenticated"
import { closeBurger } from "./handleBurgerMenu"
import { useTranslation } from "~/i18n"
import { TFunction } from "next-i18next"

const MyContainer = styled.div`
  overflow: hidden;
  position: fixed;
  width: 100vw;
  height: 100vh;
  display: none;
  z-index: 10000;
  p {
    /* font-size: 14px */
  }
`

const Background = styled.div`
  background-color: rgba(0, 0, 0, 0.7);
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  position: absolute;
  display: none;
`

const Content = styled.div`
  padding: 20px 0 0 0;
  padding-bottom: 60px;
  height: 100vh;
  width: 320px;
  background-color: #fff;
  position: absolute;
  top: 0;
  right: 0;
  transform: translateX(320px);
  transition: 250ms;
  overflow-y: scroll;
`

const CloseIcon = styled.div`
  position: absolute;
  right: 20px;
  top: 30px;
  z-index: 2;
`

const Section = styled(Box)`
  height: auto;
  margin: 16px;
`

const Item = styled(StyledLink)`
  display: block;
  font-size: 16px;
  padding: 8px;
  transition: background-color 320ms;
  border-radius: 8px;
  :hover {
    background-color: rgba(0,0,0,0.1);
    cursor: pointer;
    font-weight: 600;
  }
`

interface Props {
  onclick?: any, separator?: boolean, link: string, text: string,
  type?: string,
  color?: string
  isBlog?: boolean
}
const getMenu = (t: TFunction): Array<Props> => ([
  { text: t`Danh sách đầu tư của tôi`, link: ROUTES.MY_INVESTMENTS },
  { text: t`Quản lý Mua / Bán`, link: ROUTES.TRADING_ORDERS },
  { text: t`Tài khoản`, link: ROUTES.UPDATE_PROFILE },
  { text: t`Xác thực`, link: ROUTES.VERIFY_IDENTITY },
  { text: t`Mời bạn bè`, link: ROUTES.INVITE_OTHERS },
  { text: t`Áp dụng mã giới thiệu`, link: ROUTES.REFERRAL },
])

const getPublicMenu = (t: TFunction): Array<Props> => ([   
  { text: t`Chứng chỉ quỹ`, link: ROUTES.MF_INFO, isBlog: true },
  { text: t`Chứng khoán`, link: ROUTES.STOCK_INFO, isBlog: true },
  { text: t`Tích lũy`, link: ROUTES.SAVING_INFO, isBlog: true }, 
  { text: t`Chứng chỉ tiền gửi`, link: ROUTES.CD_INFO, isBlog: true },
  { text: t`Bất động sản`, link: ROUTES.PROPERTY_LIST },
  { text: t`Blog`, link: ROUTES.BLOG, isBlog: true },
  { text: t`Hỗ trợ`, link: ROUTES.SUPPORT, isBlog: true },
  { text: t`Báo Chí`, link: ROUTES.PRESS },
  { text: t`Về Chúng Tôi`, link: ROUTES.ABOUT_US },
])

const BurgerMenu = () => {

  const { user } = useUser()
  const [t] = useTranslation()

  const menu = useMemo(() => {

    if (!user) return null;

    const _menu = getMenu(t)
    const list = _menu.map(item => (
      <Link href={item.link} key={item.link} >
        <Item onClick={closeBurger}>
          {item.text}
        </Item>
      </Link>
    ))
    return (
      <Section>
        {list}
      </Section>
    )
  }, [user, t])


  const publicMenu = useMemo(() => {
    const _menu = getPublicMenu(t)
    const list = _menu.map(item => {
      return (
        item.isBlog ?
          <Item target='_blank' href={item.link} key={item.text}>
            {item.text}
          </Item>
          :
          <Link href={item.link} key={item.link}>
            <Item onClick={closeBurger}>
              {item.text}
            </Item>
          </Link>

      )
    })
    return (
      <Section>
        {list}
        <Text padding='8px'>
          {t`Hotline`}
          {": "}
          <StyledLink href={`tel:${HOTLINE}`}>
            <strong>
              {HOTLINE}
            </strong>
          </StyledLink>
        </Text>
      </Section>
    )
  }, [t])

  const signout = useCallback((evt: any) => {
    evt.preventDefault()
    signOut({ withSignOutMutation: true })
  }, [])

  const loginSection = useMemo(() => {
    if (user) {
      return (
        <Section height='auto' style={{ textAlign: 'center' }}>
          <Avatar size={70} src={user?.avatar} />
          <Text bold centered>
            {`${user?.kyc?.last_name} ${user?.kyc?.first_name}`}
          </Text>
          <Text size={14} centered>
            {user?.email}
          </Text>
        </Section>
      )
    }
    return (
      <Section height='auto' style={{ textAlign: 'center' }}>
        <Box flex>
          <Link href={ROUTES.SIGN_IN} >
            <Button onClick={closeBurger} style={{ height: 40 }} margin='0 16px'>
              <Text>
                {t`Đăng Nhập`}
              </Text>
            </Button>
          </Link>
          <Link href={ROUTES.SIGN_UP} >
            <Button onClick={closeBurger} primary style={{ height: 40 }} border='0'>
              <Text color='#fff'>
                {t`Đăng ký`}
              </Text>
            </Button>
          </Link>
        </Box>
      </Section>
    )
  }, [user])

  return (
    <MyContainer id='header-burger-container'>
      <Background id='header-burger-menu-bg' className='header-burger-close' />
      <Content id='header-burger-menu-content'>
        <CloseIcon>
          <StyledLink style={{ color: '#000' }} href='#' className='header-burger-close'>
            <Icon bold size={24} name='exit' />
          </StyledLink>
        </CloseIcon>
        {/* {loginSection} */}
        <Separator />
        <Box padding='20px 0 0 0'>
          {publicMenu}
          <Separator />
          {menu}
          {user && <Separator />}
          {user && (
            <Section>
              <Item onClick={signout} style={{ color: '#ff5a5f' }}>
                {t`Đăng xuất`}
              </Item>
            </Section>
          )}
        </Box>
      </Content>
    </MyContainer>
  )
}

export default BurgerMenu
